export enum EventSeriesQASelectors {
    EVENTFEED = 'eventfeed',
}